import { render, staticRenderFns } from "./PdpTiles.vue?vue&type=template&id=2467d02a&scoped=true&"
import script from "./PdpTiles.vue?vue&type=script&lang=js&"
export * from "./PdpTiles.vue?vue&type=script&lang=js&"
import style0 from "./PdpTiles.vue?vue&type=style&index=0&id=2467d02a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467d02a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PdpTilesForSize: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpTilesForSize.vue').default,PdpVariantSelector: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpVariantSelector.vue').default,PdpTilesForFeel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpTilesForFeel.vue').default,PdpTilesForBase: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/pdp/PdpTilesForBase.vue').default})
